import { Colors } from 'core/CssVariables';

export enum TIconNames {
  PLAY_CIRCLE = 'play-circle',
  COMMENT = 'comment',
  ERROR_FILLED = 'error-filled',
  UNDO = 'undo',
  FILTER = 'filter',
  PAYMENT = 'payment',
  SCHOOL = 'school',
  PLUS_CIRCLE = 'plus-circle',
  EMAIL = 'email',
  PHONE = 'phone',
  ENVELOPE = 'envelope',
  MOBILE_PHONE = 'mobile-phone',
  FILE_ICON = 'file-icon',
  FAX = 'fax',
  DOC = 'doc',
  DOWNLOAD = 'download',
  DOWNLOAD_ARROW = 'download-arrow',
  CALENDAR_FILLED = 'calendar-filled',
  CALENDAR = 'calendar',
  CALENDAR_WITH_DATES = 'calendar-with-dates',
  VERIFIED = 'verified',
  CAKE = 'cake',
  SCALES = 'scales',
  GENDER = 'gender',
  PETS_POW = 'pets_pow',
  FACT_CHECK = 'fact_check',
  CHECK_FILLED = 'check-filled',
  CHECK_POLYGON = 'check-polygon',
  CLOSE_POLYGON = 'close-polygon',
  BUILDINGS = 'buildings',
  BUILDING_PERSON = 'building-person',
  KEY_SETTINGS = 'key-setting',
  OPEN_DOOR = 'open-door',
  PALETTE = 'palette',
  GPS = 'gps',
  CAMERA = 'camera',
  FEMALE = 'female',
  MALE = 'male',
  CLOSE_CIRCLE = 'close-circle',
  LOGO_WITH_TEXT = 'logo-with-text',
  LOGO_WITH_TEXT_DARK = 'logo-with-text-dark',
  CALENDAR_ICON = 'calendar-icon',
  ARROW_LEFT_WITH_TALE = 'arrow-left-with-tale',
  ARROW_DROPDOWN = 'arrow-dropdown',
  ARROW_RIGHT = 'arrow-right',
  ARROW_LEFT = 'arrow-left',
  ARROW_FILLED = 'arrow-filled',
  BLOCK = 'block',
  CHECK_ROUNDED = 'check-rounded',
  CHECK_OUTLINED = 'check-outlined',
  WARNING_OUTLINED = 'warning-outlined',
  CLOCK = 'clock',
  THREE_DOTS_FILLED_CIRCLE = 'three-dots-filled-circle',
  CLOCK_FILLED = 'clock-filled',
  DASHBOARD = 'dashboard',
  DELETE = 'delete',
  DONE = 'done',
  DRAG = 'drag',
  EDIT = 'edit',
  EXPAND = 'expand',
  EYE_HIDE = 'eye-hide',
  EYE_SHOW = 'eye-show',
  ENTER = 'enter',
  GROUP = 'group',
  HIGHLIGHT_OFF = 'highlight-off',
  INFO = 'info',
  LAPTOP = 'laptop',
  LOCK = 'lock-icon',
  MENU = 'menu',
  NOTIFICATION = 'notification',
  OPEN_WITH = 'open-with',
  PEOPLE = 'people',
  PERSON = 'person',
  PERSON_FILLED = 'person-filled',
  PERSON_ADD = 'person-add',
  PERSON_REMOVE = 'person-remove',
  PLAY_VIDEO = 'play-video',
  PLUS = 'plus',
  REPORT = 'report',
  SEARCH = 'search',
  SETTINGS = 'settings-filled',
  TASK = 'task',
  TICKET = 'ticket',
  UNREAD = 'unread',
  UPLOAD = 'upload',
  FILTER_TABLE = 'filter-table',
  COLLAPSE = 'collapse',
  ASSIGNMENT = 'assignment',
  LEFT_ARROW = 'left-arrow',
  RIGHT_ARROW = 'right-arrow',
  BUSINESS_BAG = 'business_bag',
  PROFILE = 'profile',
  PROFILE_ICON = 'profile-icon',
  CASE = 'case',
  PET_POW = 'pets_pow',
  LOGOUT = 'logout',
  SCHEDULE = 'schedule',
  LOCATION = 'location',
  WEBSITE = 'website',
  EARTH = 'earth',
  SEGMENT = 'segment',
  CONTACT_PHONE = 'contact_phone',
  OVERDUE_TICKET = 'overdue_ticket',
  OVERDUE_TASK = 'overdue_task',
  SLA = 'sla',
  URGENCY = 'urgency',
  MENU_DOT = 'menu_dot',
  OVERDUE = 'overdue',
  IMPORT = 'import-fill',
  CLOSE_ROUND = 'close-fill',
  CLOSE_ROUND_LIGHT = 'close-filled-white',
  COPY = 'copy',
  DUPLICATE = 'duplicate',
  VIDEO = 'video-icon',
  PET_TARGET = 'pet-target',
  VISIT_ANIMAL = 'visit-animal',
  DELETE_OUTLINED = 'delete-outlined',
}

export type TIconProps = {
  isLoading?: boolean;
  color?: Colors;
  size?: number;
  icon: string;
  className?: string;
  onClick?: (e?: MouseEvent) => void;
  dataTestId?: string;
};
